import {
  GET_MASTER_ACTIVITY,
  GET_MASTER_CATEGORY,
  GET_TIMEZONE_FOR_ONBOARDING_SCREEN,
  GET_ASSET_TYPE_FOR_ONBOARDING_SCREEN,
  LOGIN,
} from "../constants";
import { ApiCall } from "../../utils/index";
import axios from "axios";

// API for getting To Dos list from businessType
export const masterActivityData = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token, company },
    } = getState();
    const result = await ApiCall.get(
      `/master/todo/${request.business_id}`,
      token
    );

    dispatch({ type: GET_MASTER_ACTIVITY, payload: result.data });
  } catch (error) {
    request.onError();
  }
};

// API for getting Business Types
export const masterCatergoryData = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token, company },
    } = getState();
    const result = await ApiCall.get(`/master/customer-category`, token);
    dispatch({ type: GET_MASTER_CATEGORY, payload: result.data });
  } catch (error) {
    console.log(error);
    request.onError();
  }
};

// API for slide 2 and 3
export const submittingOnboard = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token, id },
    } = getState();
    const result = await ApiCall.post(
      "/onboarding/company",
      request.body,
      token
    );
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};

// API to add Teams "slide 4"
export const addTeamsOnboarding = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/onboarding/teams", request.body, token);
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};

// API for slide 5 to add multiple users
export const addUsersOnboarding = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/onboarding/users", request.body, token);
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};

// API for slide 6 to add multiple to do
export const addToDoOnboarding = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/onboarding/todos", request.body, token);
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};

// API for slide 7 to add multiple assets
export const addAssetsOnboarding = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post(
      "/onboarding/assets",
      request.body,
      token
    );
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};

// Finish Onboarding API
export const completeOnboardingProcess =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token, company },
      } = getState();
      const result = await ApiCall.post(
        "/onboarding/completed",
        request.body,
        token
      );
      request.onSuccess();
    } catch (error) {
      request.onError();
    }
  };

// Get Time Zone
export const getTimeZoneForOnboarding =
  (request) => async (dispatch, getState) => {
    try {
      const result = await ApiCall.get(`/master/timezone`);
      dispatch({
        type: GET_TIMEZONE_FOR_ONBOARDING_SCREEN,
        payload: result.data,
      });
    } catch (error) {
      request.onError();
    }
  };

export const getAssetTypesForOnboarding =
  (request) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(`/master/validation`, token);
      dispatch({
        type: GET_ASSET_TYPE_FOR_ONBOARDING_SCREEN,
        payload: result.data,
      });
    } catch (error) {
      request.onError();
    }
  };

export const checkout = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await axios.post(
      `${process.env.REACT_APP_API_URL}/stripe/checkout-session`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    cb(result.data);
  } catch (error) {
    cb(error.response.data);
  }
};

export const dummySubscription = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await axios.post(
      `${process.env.REACT_APP_API_URL}/stripe/subscribe`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    cb(result.data);
  } catch (error) {
    cb(error.response.data);
  }
};

export const customerDetail =
  (customer_id, company_id, cb) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();

      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}/stripe/stripe-customer/${customer_id}/${company_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      cb(result.data);
    } catch (error) {
      console.log(error);
      cb(error?.response?.data);
    }
  };

export const updateStripeCustomer = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await axios.post(
      `${process.env.REACT_APP_API_URL}/stripe/update-customer/${request.stripe_customer_id}`,
      request.payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    request.onSuccess();
  } catch (error) {
    request.onError();
  }
};
